module.exports = __webpack_public_path__ + "static/img/1384.fde2cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1384.jpg
// module id = 38
// module chunks = 1